<template>
  <div class="buy-credits">
    <div class="has-text-weight-bold margin-bottom-15" v-if="header">
      <slot name="header">You have no reply credits remaining</slot>
    </div>
    <img src="/static/img/competitors/lock.svg" class="margin-right-15"/>
    <a :href="subscUpgradeUrl" class="blue-link" data-track="Upgrade link">Upgrade</a>
    <slot>or purchase review credits to reply now.</slot>
    <div class="input-row is-clearfix" v-if="buy && canPurchaseReviewsAndInvites">
      <input
        class="input is-inline-block has-text-centered"
        type="number"
        min="1"
        v-model="credits"
        placeholder="Amount"
        autocomplete="off"
      /><span class="is-inline-block has-text-centered label-box">
        Review Credits
      </span>
      <span class="net-amount">R{{ mrp }} excl. vat</span>
      <a :class="[credits ? 'blue-link' : 'link-disabled']" class="margin-left-14" data-track="Purchase link"
         @click.prevent="purchaseCreditsAndOrInvites(credits)" href="#">Purchase now</a>
    </div>
  </div>
</template>

<script>
import {misc} from '@/mixins'

export default {
  name: 'BuyCredits',
  mixins: [misc],
  props: {
    buy: {
      type: Boolean,
      default: true
    },
    header: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      credits: 100
    }
  },
  computed: {
    mrp () {
      const total = this.credits * parseInt(this.reviewCreditUnitPrice.toString())
      return this.formatPrice(total)
    }
  }
}
</script>

<style scoped>
.input-row {
  margin: 14px 30px 0px;
}

input {
  width: 68px !important;
  height: 35px;
  font-size: 12px;
  color: rgba(88, 89, 91, 0.4);
  border: 1px solid rgba(88, 89, 91, 0.32);
}

.label-box {
  padding: 8px 17px 7px 24px;
  border: 1px solid rgba(88, 89, 91, 0.32);
  border-left: none;
  margin-right: 15px;
}

@media screen and (max-width: 991px) {
  .buy-credits {
    font-size: 11px;
  }

  .buy-credits img {
    vertical-align: bottom;
    margin-right: 7px !important;
  }

  .input-row {
    font-size: 12px;
    margin-left: 0;
  }
}

@media screen and (max-width: 767px) {
  .buy-credits {
    text-align: center;
    font-size: 11px;
  }

  .input-row {
    margin-right: 0;
  }

  input {
    width: 126px !important;
    margin-bottom: 20px;
  }

  .label-box {
    margin-right: 0;
    padding: 8px 18px 7px 25px;
  }

  .net-amount {
    float: left;
  }

  .input-row .blue-link {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BuyCredits.vue